import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Table } from "src/assets/imports/antdComponents";
import { ModuleType } from "src/components/SubHeader/interface";
import { StudyPageTabType } from "src/pages/Studies/models/interfaces";
import HomePageSubHeader from "src/components/HomePageSubHeader";
import CustSkeleton from "../Skeleton";
import "src/pages/Studies/components/CollabCard/style.css";
import "src/pages/Studies/components/RecentStudiesSection/style.css";
import "src/pages/Studies/style.css";

const Loading: React.FC = () => {
	const location = useLocation();
	const path = location.pathname;
	const { t } = useTranslation();

	const isStudiesRoute = path === "/" || path === "/studies";

	if (!isStudiesRoute) {
		return (
			<div role="status" className="flex justify-center items-center w-full h-full">
				<div className="animate-spin rounded-full h-10 w-10 border-t-4" style={{ borderTopColor: "var(--primary-color)" }}></div>
				<span className="sr-only">{t("Loading...")}</span>
			</div>
		);
	}

	return (
		<div className="h-full flex flex-col overflow-x-hidden studies-page-container scale-baseline-80">
			{/* Reserve Add Study button height; actual button stays hidden until Studies mounts and reads the studyUpsert feature flag */}
			<div className="flex justify-end mx-4 ml-[4.7rem] mb-0 mr-20 sticky top-[-1px] z-20 bg-white py-2 pt-4">
				<div style={{ height: "2rem" }} aria-hidden="true" />
			</div>
			<div className="flex-grow mx-4">
				<div className="ml-[4.5rem] mt-4 mb-0 mr-[4rem] my-0 mx-[6rem]">
					<div className="recent-studies-section">
						<div className="recent-studies-header">
							<h3 className="recent-studies-title">{t("Recent")}</h3>
						</div>
						<div className="recent-studies-card-section">
							{[0, 1, 2, 3].map((i) => (
								<div key={i} className="recent-study-card-wrapper">
									<CustSkeleton type="card" className="custom-study-card collab-card p-6" />
								</div>
							))}
						</div>
					</div>
				</div>

				<div data-page="studies" className="sticky top-16 z-10">
					<div className="home-page-subHeader-bread">
						<div className="flex items-center justify-center gap-12">
							<div className="flex gap-2 items-center justify-center">
								<span className="font-normal text-base-16 secondary-color">{t(StudyPageTabType.All)}</span>
							</div>
						</div>
					</div>
					<HomePageSubHeader allData={[]} renderedFrom={ModuleType.Studies} tags={[]} type="button" />
				</div>

				<div
					className="my-0 mr-[4.5rem] ml-20 focus:outline-none"
					style={{ border: "1px solid #5E80B71A", borderRadius: "12px" }}>
					<Table
						className="collab-table mb-5"
						columns={[]}
						dataSource={[]}
						pagination={false}
						showHeader={false}
						loading={true}
						bordered={false}
						tableLayout="fixed"
					/>
				</div>
			</div>
		</div>
	);
};

export default Loading;
